import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DashboardService } from '../../../services/dashboard.service';
import { BreakdownAnalysisResponse } from '../../../../maintenance/maintenance-overview/models/maintenance-overview.model';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { BreakdownAnalysisTableComponent } from '../../../../_shared/components/breakdown-analysis-table/breakdown-analysis-table.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-available-assets-breakdown-modal',
  standalone: true,
  imports: [CommonModule, BreakdownAnalysisTableComponent, TranslocoPipe],
  templateUrl: './available-assets-breakdown-modal.component.html',
  styleUrl: './available-assets-breakdown-modal.component.scss'
})
export class AvailableAssetsBreakdownModalComponent implements OnInit {
  isLoading: boolean = false;
  data: BreakdownAnalysisResponse[] = [];

  private dashboardService = inject(DashboardService);
  private errorService = inject(ErrorHandlerService);
  private readonly transloco = inject(TranslocoService);
  private cancelSubject = new Subject<void>();

  constructor(private activeModal: NgbActiveModal) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.isLoading = true;

    try {
      // TODO: Implement actual API call when ready
      // const request = {
      //   accountIds: [],
      //   timeFrom: new Date(),
      //   timeTo: new Date()
      // };
      // const response = await this.dashboardService.getAvailableAssetsBreakdown(request, this.cancelSubject);
      // if (response.data) {
      //   this.data = response.data;
      // }

      // Mock data based on the provided image
      this.data = [
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.totalVehicles'),
          previousValue: '1600',
          currentValue: '1620',
          change: '+1.25%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.underMaintenance'),
          previousValue: '100',
          currentValue: '120',
          change: '+20%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.underInspection'),
          previousValue: '50',
          currentValue: '50',
          change: '0%',
          impactOnEfficiency: 'Stable'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.notAssigned'),
          previousValue: '200',
          currentValue: '350',
          change: '+75%',
          impactOnEfficiency: 'Decreased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.assigned'),
          previousValue: '1200',
          currentValue: '1200',
          change: '0%',
          impactOnEfficiency: 'Stable'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.operational'),
          previousValue: '1400',
          currentValue: '1400',
          change: '0%',
          impactOnEfficiency: 'Stable'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.retired'),
          previousValue: '50',
          currentValue: '50',
          change: '0%',
          impactOnEfficiency: 'Stable'
        }
      ];

      this.isLoading = false;
    } catch (error) {
      this.errorService.handleError(error, {
        callback: () => {
          this.isLoading = false;
        }
      });
    }
  }

  closeModal(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}